import signaskanalyst from '@/components/sign-askanlyst-popup.vue'
import jQuery from 'jquery'
import { mapActions, mapGetters, mapState } from 'vuex'
import localStorage from '@/api/localStorage'
import {
  FETCH_DASHBOARD_RECENT_MENTIONED,
  ADDTAB,
  RESET_SEARCH_FILTER,
  SET_SEARCH_SYMBOL,
  SET_SEARCH_KEY,
  SET_CURRENT_PAGE,
  SET_SEARCH_RESULT_LOADING
} from '@/store/actions.type'
import ThePlaceHolder from '@/components/ThePlaceHolder'
import recentmention from '@/components/recentmention'
import searchresults from '@/components/searchresults'
// import events from '@/events/tabs'
export default {
  name: 'rvheader',
  created() {
    this.recentmentioned()
  },
  data() {
    return {
      resentmentionsloading: false,
      data: [],
      searchkey: ''
    }
  },
  components: {
    ThePlaceHolder,
    recentmention,
    signaskanalyst,
    searchresults
  },
  computed: {
    resentloadingStatus() {
      var dashboardstorevalue = this.dashboardstate()
        ; ( this.resentmentionsloading = dashboardstorevalue.recentmentions.isLoading ),
      ( this.data = dashboardstorevalue.recentmentions.data )
      return this.dashboardstate().recentmentions.isLoading
    },
    ...mapState( {
      isLogin: ( state ) => !state.auth.isAuthenticated
    } )
  },
  methods: {
    ...mapActions( {
      recentmentioned: FETCH_DASHBOARD_RECENT_MENTIONED,
      createRvTab: ADDTAB,
      resetfilters: RESET_SEARCH_FILTER,
      setSearchsymbol: SET_SEARCH_SYMBOL,
      setsearchkey: SET_SEARCH_KEY,
      setcurrentpage: SET_CURRENT_PAGE,
      setsearchloading: SET_SEARCH_RESULT_LOADING
    } ),

    resetFiltersValues: function () {
      this.setsearchloading( true )
    },
    submitSearch: function () {
      var searchkey = this.searchkey
      this.searchkey = ''
      this.resetFiltersValues()
      this.createTab( searchkey, 'search', 'searchkey' )
    },

    async createTab( categoryName, type, post ) {
      var tabobj = {}
      tabobj['type'] = type
      tabobj['categoryName'] = categoryName
      tabobj['post'] = post
      this.createRvTab( tabobj )
      if ( type == 'search' ) {
        localStorage.savelocalStorage( 'serachResultload', 'true' )
        this.resetfilters()
        if ( post == 'symbol' ) {
          this.setSearchsymbol( categoryName )
        }
        if ( post == 'searchkey' ) {
          this.setsearchkey( categoryName )
        }
      }
      // events.selectCurrentAcative(currentTab)
    },
    ...mapGetters( ['activeTabIndex', 'dashboardstate'] ),
    resentloadingData() {
      return this.dashboardstate().recentmentions.data
    },
    askAnlystModal: function () {
      if ( !this.isLogin ) {
        // alert('done')
      } else {
        // alert('not done')
      }
    },

    askAnlystPopup() {
      if ( this.isLogin ) {
        jQuery( '#userlogin' ).click()
      } else {
        // alert(2)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/rvheader.js